import React from 'react'
import { isAfter } from 'date-fns'
import type { AuctionBlueprintScheduledOnlineReactiveArgs } from '@adc/blueprint'

interface AuctionExtensionObserverProps {
  children: (didBidExtendAuction: boolean) => React.ReactNode
  segment: AuctionBlueprintScheduledOnlineReactiveArgs['segment']
}

// currently this component's entire functionality is just to toggle the UI from not showing the time extended tooltip
// to showing it in the UI from the first time the bid is extended as a result of a bid being placed in the final 2 minutes.
export class AuctionExtensionObserver extends React.Component<AuctionExtensionObserverProps> {
  state = {
    didBidExtendAuction: false,
  }

  componentDidUpdate(prevProps: AuctionExtensionObserverProps) {
    // if the incoming segment end date is after the previous segment end date, that indicates that it was extended
    // so we set the state at that point and leave it set to true for the remainder of the auction
    if (
      isAfter(
        new Date(this.props.segment.initial_end_date),
        new Date(prevProps.segment.initial_end_date)
      )
    ) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ didBidExtendAuction: true })
    }
  }

  render() {
    return this.props.children(this.state.didBidExtendAuction)
  }
}
